import angular from 'angular';
import integrationsComponent from './integrations.component';
import quickbooks from './quickbooks/quickbooks';
import paylocity from './paylocity/paylocity';

let integrationsModule = angular.module('integrations', [
  quickbooks.name,
  paylocity.name
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
})

.component('integrations', integrationsComponent);

export default integrationsModule;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/integrations.js